export default __webpack_public_path__ + "static/media/logo.6c1a8d62.png";